import getNextKey from './../../js/helpers/getNextKey'

function getProjectTasks (state, rootState) {
  let project = rootState.global.project.contentJson
  let activePhaseIndex = rootState.global.activePhaseIndex
  let foundGoal = project.phases[activePhaseIndex].goals.find(goal => goal.code === state.activeGoalCode)
  return foundGoal.tasks
}

function resetAllEditTasks (goals) {
  goals.forEach(goal => {
    if (goal.tasks && goal.tasks.length > 0) {
      goal.tasks.forEach(task => {
        if (task.custom && task.edit) {
          task.edit = false
        }
      })
    }
  })
}

const state = {
  activeGoalCode: null
}

const getters = {
  getActiveGoalCode: state => {
    return state.activeGoalCode
  },
  getActiveGoal: (state, getters, rootState) => {
    let activePhaseIndex = rootState.global.activePhaseIndex
    let project = rootState.global.project
    let foundGoal = project.contentJson.phases[activePhaseIndex].goals.find(goal => goal.code === state.activeGoalCode)
    if (foundGoal) {
      return foundGoal
    }
    return false
  },
  getActiveProfileGoal: (state, getters, rootState) => {
    let profile = rootState.global.profile
    let foundGoal = profile.goals.find(goal => goal.code === state.activeGoalCode)
    if (foundGoal) {
      return foundGoal
    }
    return false
  },
  // Bruges ikke?
  getActiveGoalTasks: (state, getters, rootState) => {
    return rootState.global.project.contentJson.phases[rootState.global.activePhaseIndex].goals.find(goal => goal.code === state.activeGoalCode).tasks
  },
  getProfileGoalTargets: (state, getters, rootState) => (phaseIndex, goalCode) => {
    if (phaseIndex === undefined) {
      phaseIndex = rootState.global.activePhaseIndex
    }

    if (goalCode === undefined) {
      goalCode = state.activeGoalCode
    }

    let goal = rootState.global.profile.phases[phaseIndex].goals.find(goal => goal.code === goalCode)
    if (goal && goal.targets && goal.targets.length > 0) {
      return goal.targets
    }

    return false
  }
}

const mutations = {
  setActiveGoalCode: (state, payload) => {
    state.activeGoalCode = payload
  }
}

const actions = {
  setActiveGoalCode: ({ commit, dispatch, rootState }, goal) => {
    resetAllEditTasks(rootState.global.project.contentJson.phases[rootState.global.activePhaseIndex].goals.filter(goal => goal.selected))
    commit('setActiveGoalCode', goal)
  },
  addCustomTask: ({ commit, dispatch, rootState }) => {
    let tasks = getProjectTasks(state, rootState)

    let customTask = {
      code: 'A',
      custom: true,
      edit: true,
      title: '',
      description: '',
      what: '',
      how: '',
      completedPct: 0
    }

    if (tasks.length > 0) {
      let lastTask = tasks[tasks.length - 1]
      if (lastTask.custom) {
        customTask.code = getNextKey(lastTask.code)
      }

      tasks.filter(task => task.custom).forEach(task => {
        task.edit = false
      })
    }

    tasks.push(customTask)
  },
  removeCustomTask: ({ commit, dispatch, rootState }, selectedTask) => {
    let tasks = getProjectTasks(state, rootState)

    for (let i = tasks.length - 1; i >= 0; i--) {
      if (tasks[i].code === selectedTask.code) {
        tasks.splice(i, 1)
        break
      } else {
        tasks[i].code = tasks[i - 1].code
      }
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
